import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCFsrlxSaGwYV-uAGxeC9gjAPM9yYe1hA0",
  authDomain: "golden-cars-legal-a17c7.firebaseapp.com",
  projectId: "golden-cars-legal-a17c7",
  storageBucket: "golden-cars-legal-a17c7.firebasestorage.app",
  messagingSenderId: "310938896982",
  appId: "1:310938896982:web:8fc5463fccb795e82789f7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;